import React from "react";
import "../styles.css";

const Instructions = () => {
  return (
    <div id="instructions">
      <h1>Instructions</h1>
      <h3>Background and Test Overview</h3>
      <p>
      As a certified Pilates teacher pursuing my Masters in Integrated Design and 
      Media, my research and work these past two years has centered around the 
      intersection of technology and fitness applications for teaching online 
      fitness classes. I am particularly interested in the ways these interventions
      can: enhance the learning experience of online classes, make classes more 
      accessible and equitable, and create environments where deep learning can 
      occur to build independence for and give agency to the student. 
      </p>
      <p>
      I have been working on a prototype of an experience that is a small part of
      this exploration, which is what you will be testing.
      </p>
      <p>
      This experience is a 4 panel video player, capturing multiple angles of an
      exercise on loop with an audio instruction of the exercise. The 4 panel video
      player allows you to view all 4 views simultaneously, or enlarge particular
      angles to get a closer look.
      </p>
      <p>
      What I am exploring in this test is the overall user experience of this 4 panel
      video player, as well as if this experience can help practitioners better master
      exercise and/or successfully perform them in a safe and technically adept way. 
      Your insight will be invaluable as I explore this intervention.
      </p>

      <h3>Steps to Complete your User Testing</h3>
      <p>
      After completing your reading of these instructions, you will navigate to the 
      Content page to watch, listen, and engage with 8 videos.  
      </p>

      <p>
      Each video will be titled with the name of a single Pilates exercise being 
      performed. The exercise will be performed across 4 videos simultaneously. 
      An audio clip narrating how to perform the exercise will also play alongside 
      the action. The video and audio will loop.
      </p>

      <p>
      Press the play button to start the videos and the audio; you will have the option
      to pause at any point. Double clicking on an individual video will enlarge the 
      video and place the remaining 3 views in a row underneath it. Double clicking 
      the enlarged video again will revert back to the original 4 panel view. You 
      can also use the switcher button on the toolbar to change views, which will 
      enlarge the videos from left to right. See the Navigation Guide below or on the 
      Content page to reference.
      </p>

      <img src={require('../public/HowTo_1.png')} alt='How to use video player, part 1' width='1200px'/>
      <img src={require('../public/HowTo_2.png')} alt='How to use video player, part 2' width='1200px'/>

      <p>
      If you plan on performing the exercises, make sure you are properly warmed up 
      to prevent injury. A low impact, short warm up can be found <a href="https://www.youtube.com/watch?v=VaoV1PrYft4">here</a>.
      </p>

      <p>
      After watching, listening, and engaging with the content, you will then 
      navigate to the Feedback page, and complete the survey. The survey should not 
      take more than <strong>15</strong> mins to complete.
      </p>

      <h3>Disclaimers and Reminders</h3>

      <p>
      Please note that this is still a prototype. There may be inconsistencies in 
      audio quality, or videos noticeably shot on clearly different days or times 
      of day. Please try to disregard these, for all of the video and audio content 
      still accurately depict the exercises and are not hindered by these blips. 
      </p>

      <p>
      Please note any video/video player artifacts, distortions or glitches in your 
      feedback that you found distracted from or hindered from your experience. 
      </p>

      <p>
      This website itself is not meant to be critiqued in the feedback or be treated 
      as part of the cumulative experience. This website solely services as a home 
      for all of the information and content you will need to view this prototype 
      and complete the user test.
      </p>

      <p>
      Survey results will be anonymous; your name and email will not be collected. 
      I will be the sole handler of the collected information. Open-ended comments 
      may be used in presentations. Please email me at sca297@nyu.edu if you have 
      any questions or concerns regarding your feedback. 
      </p>

    </div>
  );
};

export default Instructions;
